import Page from './CustomFactorBtn.js';
import { connect } from 'react-redux';
import { getCustomKPIList } from './utils.js';

const mapStateToProps = state => {
    const { system } = state;
    const { customFactors } = system;
    return {
        customFactors,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getCustomKPIList: () => dispatch(getCustomKPIList),
    };
};

const WrapperedPage = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Page);

export default WrapperedPage;